import { Editor, Transforms } from 'slate';
import { BLOCK_TABLE, BLOCK_TABLE_CELL, BLOCK_TABLE_ROW } from '../types';

export const deleteColumn = (editor) => {
  const currentCell = Editor.above(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  });
  const currentRow = Editor.above(editor, {
    match: n => n.type === BLOCK_TABLE_ROW,
  });
  if (currentCell) {
    const currentTable = Editor.above(editor, {
      match: n => n.type === BLOCK_TABLE,
    });
    if (currentTable) {
      const [,cellPath] = currentCell;
      const [rowNode] = currentRow;
      const [tableNode, tablePath] = currentTable;
      const col = tableNode.col;
      if (col === 1) {
        Transforms.removeNodes(editor, {
          at: tablePath,
        });
      } else {
        const currentColIdx = cellPath[cellPath.length - 1];
        // getting the real col index by taking into account the colspans
        const realColIdx = rowNode.children?.reduce((total, cell, i) => {
          if (i < currentColIdx) {
            total += cell.colspan || 1;
          } else if (i === currentColIdx) {
            total += 1;
          }
          return total;
        }, 0);

        // Getting the cells to delete or modify
        const tableCells = [...Editor.nodes(editor, {
          match: (n) => {
            return  n.type === BLOCK_TABLE_ROW
          },
          at: tablePath
        })].map(([node, path]) => {
         
          let total = 0;
          let cell;
          node.children.find((c, i) => {
            const { colspan = 1 } = c;
            total += colspan;

            if (realColIdx <= total) {
              cell = [c, [...path, i]]
              return true
            }

            return false;
          })

          return cell
        })
        // Deleting the cells when colspan is 1
        tableCells.map(([cell, path]) => {
          const { colspan = 1 } = cell;
          if (colspan > 1) {
            Transforms.setNodes(
              editor,
              {
                colspan: colspan - 1,
              },
              {
                at: path,
              },
            );
          } else  {
            Transforms.removeNodes(editor, {
              at: path,
            });
          }
        })
        Transforms.setNodes(
          editor,
          {
            col: col - 1,
          },
          {
            at: tablePath,
          },
        );
      }
    }
  }
};